import { ucfirst } from '~/lib/Utils';
import { formatDate } from '~/lib/DateTime';

export function getPaymentMethodDetails(paymentMethod) {
    const title = `${ucfirst(paymentMethod?.metadata?.card?.brand)} ending in ${paymentMethod?.metadata?.card?.last4}`;
    const description = `expires ${paymentMethod?.metadata?.card?.exp_month}/${paymentMethod?.metadata?.card?.exp_year}, last used ${formatDate(paymentMethod.used_at)}`;

    return { title, description };
}
